export const SMS_OTP_SEND_PATH = "/otp/sms/send" as const;
export const SMS_OTP_VERIFY_REMINDER_PATH = "/otp/sms/reminder/verify" as const;

export type SmsOtpSendRequest = {
  countryCode: string;
  phoneNumber: string;
};

export type SmsOtpVerifyRequest = SmsOtpSendRequest & {
  otp: string;
};

export type SmsOtpSendSuccessResponse = string;

export type SmsOtpVerifySuccessResponse = {
  message: string;
};

export type SmsOtpErrorResponse = {
  error?: string;
};
